import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaDocumentoFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  handleChange,
  setFieldValue
}) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      setFieldValue('fechaVencimiento', e.target.value)
    },
    [handleChange, setFieldValue]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('inputDate-fechaVencimiento', e, {
      timeOutTime: 200
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC DOC' htmlFor='inputDate-modal-fechaDocumento' md={12} />
      <Col md={12}>
        <Field name='fechaDocumento'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='inputDate-modal-fechaDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
              onChange={onChange}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaDocumentoFormGroup)
